module.exports = __webpack_public_path__ + "img/brushes_cn.3ae94cf.jpg";